import { StarIcon } from '@heroicons/react/24/outline';
import { Badge, Box, Group, Loader, Text } from '@mantine/core';
import { PersonTechnology } from '../../../../../types/technology';

interface FavoriteTechnologiesProps {
  technologies: PersonTechnology[];
  loading: boolean;
}

export function FavoriteTechnologies({ technologies, loading }: FavoriteTechnologiesProps) {
  return (
    <Box mb="lg">
      <Group mb="xs">
        <StarIcon width={18} />
        <Text fw={600} size="md">Favorite Skills & Technologies</Text>
      </Group>

      {loading ? (
        <Box py="md" style={{ display: 'flex', justifyContent: 'center' }}>
          <Loader size="sm" />
        </Box>
      ) : technologies.length === 0 ? (
        <Text size="sm" c="dimmed" fs="italic">
          No favorite skills & technologies found.
        </Text>
      ) : (
        <Group gap="xs">
          {technologies.map(tech => (
            <Badge
              key={tech.id}
              size="md"
              color="blue"
              variant="filled"
            >
              {tech.technology?.name || 'Unknown Technology'}
            </Badge>
          ))}
        </Group>
      )}
    </Box>
  );
}

